const vi = {
    9000001: "Cúp Giáng Sinh 2023",
    9000002: "Giải vô địch SuperEx Futures",
    9000003: "Tổng giải thưởng cuộc thi trị giá 30.000 USDT",
    9000004: "Số người tham gia cuộc thi",
    9000005: "Đã mở khóa hồ bơi giải thưởng (USDT)",
    9000006: "Vòng loại xếp hạng khối lượng giao dịch ",
    9000007: "Cuộc thi xếp hạng tỷ suất lợi nhuận ",
    9000008: "Cuộc thi xếp hạng lợi nhuận",
    9000009: `Cuộc thi xếp hạng khối lượng giao dịch: Mở khóa giải thưởng cao nhất là quỹ tiền thưởng <span style="color: #ffc72b;">20,000</span> USDT`,
    9000010: "Theo số lượng người tham gia, số lượng người tham gia càng lớn thì tổng giải thưởng sẽ được mở khóa càng lớn, lên tới 20.000USDT",
    9000011: "Số tiền trong hũ thưởng",
    9000012: "Trong suốt thời gian diễn ra sự kiện, cập nhật hàng ngày vào lúc 10:00 (UTC)",
    9000013: "Ước tính phần thưởng",
    9000014: "Khối lượng giao dịch hợp đồng tương lai tích lũy",
    9000015: "Quy định về phần thưởng",
    9000016: "Theo số lượng người tham gia, số lượng người tham gia càng lớn thì tổng giải thưởng sẽ được mở khóa càng lớn, lên tới 20.000USDT",
    9000017: "Số tiền trong hũ thưởng (USDT)",
    9000018: "Xếp hạng lợi nhuận của hoạt động",
    9000019: "Đăng ký",
    9000020: "Xếp hạng doanh thu từ hoạt động",
    9000021: "Đã kết thúc",
    9000022: `Cuộc thi xếp hạng tỷ suất lợi nhuận - Nhận tiền thưởng <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000023: `Cuộc thi xếp hạng lợi nhuận - Nhận tiền thưởng <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000024: "Tỷ lệ lợi nhuận tích lũy của hợp đồng tương lai",
    9000025: "Tổng lợi nhuận hợp đồng tương lai tích lũy",
    9000026: "Chưa bắt đầu",
    9000027: "50 người tham gia hàng đầu trong cuộc thi xếp hạng lợi nhuận sẽ được trao thưởng. Để biết chi tiết, vui lòng tham khảo quy tắc phần thưởng xếp hạng để nhận phần thưởng.",
    9000028: "50 người tham gia đứng đầu về khả năng sinh lời sẽ được thưởng, vui lòng tham khảo Quy tắc thưởng xếp hạng giao dịch để nhận phần thưởng.",
    9000029: "Xếp hạng số lượng giao dịch của hoạt động",
    9000030: "Đăng ký thành công",
    9000031: "Tải xuống ứng dụng",
    9000032: "Trở về trang chủ",

    //合约交易积分
    9100001: 'Lưu điểm',
    9100002: 'Nhận Airdrop',
    9100003: 'Đổi phần thưởng',
    9100004: 'Số dư điểm',
    9100005: 'Chi tiết',
    9100006: 'Điểm đăng nhập',
    9100007: 'Điểm giao dịch',
    9100008: 'Điểm mời',
    9100009: 'Điểm thưởng',
    9100010: 'Rút thăm trúng thưởng',
    9100011: 'Nhận điểm',
    9100012: 'Quy tắc điểm',
    9100013: 'Chi tiết điểm',
    9100014: 'Bạn cần phải đăng ký để tham gia vào sự kiện này. Bấm để đăng ký',
    9100015: 'Đã giao dịch trong {day} ngày liên tiếp và kiếm được {num} điểm',
    9100016: 'Đã kiếm được {num} điểm hôm nay',
    9100017: 'Tổng giải thưởng điểm',
    9100018: 'Mỗi lần rút may mắn tiêu tốn {point} điểm và có thể rút tối đa {num} lần rút may mắn mỗi ngày.',
    9100019: 'Số lần rút thăm may mắn ngày hôm nay',
    9100020: 'Người dùng',
    9100021: 'Điểm',
    9100022: 'Số dư điểm không đủ',
    9100023: 'Số dư điểm không đủ. Hãy tích lũy điểm trước khi tham gia rút thăm may mắn.',
    9100024: 'Số lần rút thăm may mắn đã đạt đến giới hạn!',
    9100025: 'Số lần rút thăm may mắn ngày hôm nay đã đạt đến giới hạn. Hãy thử lại vào ngày mai.',
    9100026: 'Làm thế nào để có được điểm',
    9100027: 'Đăng ký tham gia hoạt động kiếm điểm giao dịch hợp đồng tương lai để kiếm điểm.',
    9100028: 'Đăng kí thành công',
    9100029: 'Bạn đã đăng ký tham gia hoạt động giao dịch hợp đồng tương lai để kiếm điểm. Đi và giao dịch để kiếm thêm điểm (bạn sẽ không còn được hưởng phần thưởng hoa hồng và hoàn tiền nữa)',
    9100030: 'Sau khi hủy đăng ký, bạn sẽ không nhận được điểm nữa. Bạn có chắc chắn muốn hủy đăng ký của mình không?',
    9100031: 'Trung tâm hoạt động điểm giao dịch',
    9100032: 'Nhận điểm',
    9100033: 'Bạn cần phải đăng ký để tham gia vào sự kiện này. Bấm để đăng ký',
    9100034: 'Bạn có thể kiếm điểm bằng cách giao dịch hợp đồng tương lai liên tục',
    9100035: 'Người dùng có thể kiếm điểm cho tất cả các giao dịch hợp đồng tương lai',
    9100036: 'Bảng xếp hạng điểm',
    9100037: 'Năm người dùng đứng đầu trong bảng xếp hạng giao dịch hàng ngày sẽ nhận được thêm điểm thưởng',
    9100038: 'Người dùng được mời nhận được điểm và người mời có thể nhận được điểm thưởng.',
    9100039: '{guy} Đã giành được <span style="color:#D9A31A"> {num} điểm!</span>',
    9100040: 'Hãy thử rút thăm may mắn ngay bây giờ!',
    9100041: 'Chúc mừng bạn đã nhận được',
    9100042: 'Các loại',
    9100043: 'Ở lại trang này',
    9100044: 'Đăng ký tham gia',
    9100045: 'Tiếp tục giao dịch',
    9100046: 'Hiện tại không có hoạt động nào đang diễn ra. Hãy theo dõi những tin tức mới nhất...',
    9100047: 'Đổi token SCS',
    9100048: '',
    9100049: '',

    9100050: 'Ngày',
    9100051: 'Chọn ngày bắt đầu',
    9100052: 'Chọn ngày kết thúc',
    9100053: 'đến',
    9100054: 'Loại ',

    9100055: 'Điểm kiếm được = Khối lượng giao dịch * 1% (Tỉ lệ sẽ được điều chỉnh thêm khi tổng khối lượng giao dịch của nền tảng tăng lên)',
    9100056: 'Ví dụ: người dùng sử dụng một vị thế có mức ký quỹ 100 USDT*100X=10000 USDT',
    9100057: 'Sau đó, bạn chỉ cần nạp 100 USDT để nhận được 100 điểm',
    9100058: 'Điểm giao dịch là cách duy nhất để có được token nền tảng SCS',
    9100059: 'Điểm thưởng bổ sung = tổng điểm trong ngày * tỷ lệ phần thưởng xếp hạng',
    9100060: 'Xếp hạng',
    9100061: 'Hạng nhất',
    9100062: 'Hạng hai',
    9100063: 'Hạng ba',
    9100064: 'Hạng bốn',
    9100065: 'Hạng năm',
    9100066: 'Người dùng được mời nhận được điểm và người mời có thể nhận được điểm thưởng.',
    9100067: 'Yếu tố cấp độ',
    9100068: 'Công thức tính: điểm giới thiệu thu được = điểm người được mời * hệ số cấp độ',
    9100069: 'Hệ số cấp độ sẽ được điều chỉnh theo tình hình thực tế',
    9100070: 'Ví dụ: Người dùng B tham gia vào một hoạt động tích điểm và người mời của họ là người dùng A và số lượng lời mời từ người dùng A đã đạt Cấp 3. Người dùng B đã tích lũy điểm = 360.000;',
    9100071: 'Khi đó số điểm khuyến mãi tích lũy mà người dùng A có thể nhận được = 360000* 30% = 108.000 ',
    9100072: 'Hệ số thưởng',
    9100073: '1 Người dùng giao dịch',
    9100074: 'Khối lượng giao dịch đạt tới 5 triệu',
    9100075: 'Khối lượng giao dịch đạt tới 20 triệu',

    9100076: 'Chuyển ',

    //热币
    9100080: 'Đã kết thúc',
    9100081: `Nhấp vào 'Tham gia ngay' để giành phần thưởng`,
    9100082: 'Xem quy tắc',
    9100083: 'Tham gia ngay',
    9100084: 'Hoạt động',
    9100088: 'Buôn bán',
    9100089: 'Gửi',
    9100090: 'Bạn đã đăng ký rồi.',

    9100091: 'Sự kiện này đã kết thúc, hãy đón chờ sự kiện tiếp theo!',
    9100092: 'Sự kiện chưa bắt đầu, vui lòng đợi tin tức.',
    9100093: '',
    9100094: '',

    //自由区二维码分享页面
    9100095: 'SuperEx Free Market, thế giới tiền điện tử của người dùng, do người dùng, vì người dùng',
    9100096: 'Mở ứng dụng',
    9100097: '',
    9100098: '',
}

export default vi



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/vi.js